var React = require('react');

function IcReply (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.586 12l-3.293-3.293 1.414-1.414 5 5 .707.707-.707.707-5 5-1.414-1.414L16.586 14H9a5 5 0 01-5-5V8h2v1a3 3 0 003 3h7.586z","fill":"currentColor"}));
}

IcReply.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = IcReply;

IcReply.default = IcReply;
